import * as React from 'react';
import Dialog from 'rc-dialog';
import FilledError from 'acud-icon/lib/icons/FilledError';
import OutlinedClose from 'acud-icon/lib/icons/OutlinedClose';
import FilledSuccess from 'acud-icon/lib/icons/FilledSuccess';
import FilledWarn from 'acud-icon/lib/icons/FilledWarn';
import FilledInfo from 'acud-icon/lib/icons/FilledInfo';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider';
import Button from '../button';
import { canUseDocElement } from '../_util/styleChecker';
import { getTransitionName } from '../_util/motion';
let mousePosition;
// 100ms 内发生过点击事件，则从点击位置动画展示
const getClickPosition = (e) => {
    mousePosition = {
        x: e.pageX,
        y: e.pageY
    };
    setTimeout(() => {
        mousePosition = null;
    }, 100);
};
// 只有点击事件支持从鼠标位置动画展开
if (canUseDocElement()) {
    document.documentElement.addEventListener('click', getClickPosition, true);
}
// type SizeType = 'small' | 'normal' | 'large' | 'extraLarge';
var SizeType;
(function (SizeType) {
    SizeType["small"] = "sm";
    SizeType["normal"] = "md";
    SizeType["large"] = "lg";
    SizeType["extraLarge"] = "xl";
})(SizeType || (SizeType = {}));
;
const DialogType = {
    sucess: { className: 'sucess', icon: <FilledSuccess color='@S6'/> },
    warning: { className: 'warning', icon: <FilledWarn color='@W6'/> },
    info: { className: 'info', icon: <FilledInfo color='@B6'/> },
    error: { className: 'error', icon: <FilledError color='@E6'/> }
};
const DialogBox = props => {
    const { getPopupContainer, getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('dialogbox');
    const rootPrefixCls = getPrefixCls();
    const handleCancel = e => {
        var _a;
        const { onCancel } = props;
        if (((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.className) === `${prefixCls}-wrap`) {
            return;
        }
        onCancel === null || onCancel === void 0 ? void 0 : onCancel(e);
    };
    const handleOk = (e) => {
        const { onOk } = props;
        onOk === null || onOk === void 0 ? void 0 : onOk(e);
    };
    const defaultRenderFooter = () => {
        const { okText, cancelText, confirmLoading } = props;
        return (<>
            <Button onClick={handleCancel} type="default">{cancelText || '取消'}</Button>
            <Button onClick={handleOk} loading={confirmLoading} type="primary">
                {okText || '确定'}
            </Button>
        </>);
    };
    const closeIconToRender = (<span className={`${prefixCls}-close-x`}>
            <OutlinedClose className={`${prefixCls}-close-icon`}/>
        </span>);
    const { visible, size, className, title, content, type, footer } = props;
    return (<Dialog {...props} footer={footer || defaultRenderFooter()} title='' width={400} className={classNames(className, `${prefixCls}-${SizeType[size]}`)} getContainer={getPopupContainer} prefixCls={prefixCls} visible={visible} mousePosition={mousePosition} onClose={handleCancel} transitionName={getTransitionName(rootPrefixCls, 'zoom')} maskTransitionName={getTransitionName(rootPrefixCls, 'fade')} closeIcon={closeIconToRender}>
            <div className={`${prefixCls}-content-con`}>
                <div className={classNames((DialogType[type] || 'warning').className, `${prefixCls}-content-icon`)}>
                    {DialogType[type].icon}
                </div>
                <div>
                    {title && <div className={`${prefixCls}-content-title`}>{title}</div>}
                    <div className={`${prefixCls}-content-text`}>{content}</div>
                </div>
            </div>
        </Dialog>);
};
DialogBox.defaultProps = {
    size: 'small',
    visible: false,
    confirmLoading: false,
    type: 'warning'
};
export default DialogBox;
